import api from './client';
export interface MeterMetric { id: string; label: string; column: string; value: number | null }
export interface MeterSource {
  source: 'meter_data' | 'modbus_meter_data'; label: string; timestamp: string | null; localDate: string | null;
  freshness: 'recent' | 'stale' | 'no-data'; metrics: MeterMetric[];
}
export interface PowerMeter {
  id: number; uuid: string; name: string; serialNumber: string | null; brand: string | null; model: string | null;
  scope: string; sources: MeterSource[];
}
export interface MeterHistory { rows: Array<{ timestamp: string; value: number | null }>; truncated: boolean }
export type MeterScope = 'plant' | 'site';
export async function fetchMeters(uuid: string, scope: MeterScope, signal?: AbortSignal): Promise<{ timezone: string; meters: PowerMeter[] }> {
  return (await api.get(`/${scope === 'site' ? 'sites' : 'powerplants'}/${uuid}/meters`, { signal })).data;
}
export async function fetchMeterHistory(uuid: string, params: { meterId: number; source: MeterSource['source']; metric: string; date: string }, signal?: AbortSignal, scope: MeterScope = 'plant'): Promise<MeterHistory> {
  return (await api.get(`/${scope === 'site' ? 'sites' : 'powerplants'}/${uuid}/meters/history`, { params, signal })).data;
}
